<template>
  <a-modal v-model="visible" title="添加成员" @ok="handleOk" okText="添加" cancelText="取消">
    <div class="member-head-content">
      <!-- 选择邀请成员 -->
      <a-row style="display: flex; align-items: center">
        <a-col :offset="1" :span="6" class="member-input">选择成员：</a-col>
        <a-col :span="14" class="member-input"
          ><a-select
            show-search
            placeholder="搜索加入项目的成员名称"
            style="width: 100%"
            :default-active-first-option="false"
            :show-arrow="false"
            :filter-option="false"
            :not-found-content="null"
            :value="memberValue"
            @search="handleSearch"
            @change="handleChange"
          >
            <a-select-option v-for="item in memberSelect" :value="item.realname" :key="item.id"> {{ item.realname }} </a-select-option>
          </a-select>
        </a-col>
      </a-row>
      <!-- 选择项目权限 -->
      <a-row style="margin-top: 36px; display: flex; align-items: center">
        <a-col :offset="1" :span="6" class="member-input">选择角色权限：</a-col>
        <a-col :span="14" class="member-input"
          ><a-select show-search placeholder="普通成员" style="width: 100%" v-model="params.roleType">
            <a-select-option value="0"> 所有者 </a-select-option>
            <a-select-option value="1"> 管理员 </a-select-option>
            <a-select-option value="2"> 成员 </a-select-option>
          </a-select></a-col
        >
      </a-row>
      <!-- 选择到期日 -->
      <a-row style="margin-top: 36px; display: flex; align-items: center">
        <a-col :offset="1" :span="6" class="member-input">访问到期日期：</a-col>
        <a-col :span="14" class="member-input">
          <a-date-picker style="width: 100%" @change="onChange" />
        </a-col>
      </a-row>
    </div>
  </a-modal>
</template>
<script>
import departUserApi from "@/request/api-manager/departUser.js";

export default {
  name: "AddMember",
  data() {
    return {
      params: {
        userId: '',
        roleType: '0',
      },
      memberValue: '',
      memberSelect: []
    };
  },
  props: {
    visible: {
      type: Boolean,
    },
    depId: String
  },
  mounted() {
    this.getselectData()
  },
  methods: {
    getselectData(name = '') {
      departUserApi.getUsers({
        realname: `*${name}*`
      }).then(res => {
        this.memberSelect = res.result.records
      })
    },
    handleSearch(value) {
      this.getselectData(value)
    },
    handleChange(value) {
      this.memberValue = value
      this.params.userId = this.memberSelect.filter( item => item.realname == value )[0].id
      this.getselectData(value)
    },
    onChange(date, dateString) {
      console.log(date, dateString);
    },
    handleOk() {
      let params = {
        ...this.params,
        depId: this.depId
      }
      this.$emit("handleOk",params);
    },
  },
};
</script>
<style scoped>
@import "./index.css";
</style>